// React
import React from "react";

import './infopages.css';

export const ComingSoon = () => {

    return (
        <div id='ComingSoon'>
            <div className='image-holder' style={{marginBottom:'25px'}}>
                <img src="./assets/img/logo.svg" className='' alt='Yety Logo'/>               
            </div>
            <div class='neon'>
                <div>
                    Coming Soon
                </div>
            </div>
        </div>
    );

};

export default ComingSoon;


// WEBPACK FOOTER //
// ./src/Views/InfoPages/ComingSoon.js